import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { firstValueFrom, map } from "rxjs";
import { UserRegistrationService } from "./core/auth/user-registration.service";

export const isNotRegisteredGuard: CanActivateFn = async () => {
  const userRegistration = inject(UserRegistrationService);
  return firstValueFrom(
    userRegistration.userDetailsChanges.pipe(map((user) => !user.isRegistered)),
  );
};
